// University of Florida's undergraduate majors (#2840). Read on 2026-10-01
// from the official Undergraduate Catalog's Programs page
// (catalog.ufl.edu/UGRD/programs/), filtered to "Major", and each program's
// own catalog page for its college and degree ("About this Program"):
// every main-campus bachelor's major kept; minors, certificates, the UF
// Online versions (separate listings of the same majors), the preprofessional
// Pharmacy track and Exploring Engineering Studies (no degree) left out.
// Degrees are written as the catalog writes them (full names, not
// abbreviations); a major offered as both a BA and a BS appears once per
// degree. The catalog's disambiguators (" | CALS", " | CLAS", " | BA") are
// dropped because the group already names the college, and its other " | "
// separators are shown in parentheses. The Fisher School of Accounting and
// the Heavener School of Business sit in the Warrington College of Business;
// the School of Natural Resources and Environment's majors list the College
// of Agricultural and Life Sciences as their college. The catalog page for
// Natural Resource Conservation names the degree Bachelor of Science in
// Forest Resources and Conservation. The KB's majors list was the starting
// point; the catalog wins.
const majors = {
    "slug": "university-of-florida",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UF's official Undergraduate Catalog, grouped by the college or school that offers it, with the degree it leads to. UF Online versions, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agricultural and Life Sciences",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "Agricultural Education and Communication",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Agricultural Operations Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Animal Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Botany",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Dietetics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Entomology and Nematology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Family, Youth and Community Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Food Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Food and Resource Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Forest Resources and Conservation",
                    "degree": "Bachelor of Science in Forest Resources and Conservation"
                },
                {
                    "name": "Geomatics",
                    "degree": "Bachelor of Science in Geomatics"
                },
                {
                    "name": "Interdisciplinary Studies (Environmental Management in Agriculture and Natural Resources)",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Marine Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Microbiology and Cell Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Natural Resource Conservation",
                    "degree": "Bachelor of Science in Forest Resources and Conservation"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Plant Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Soil, Water, and Ecosystem Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Wildlife Ecology and Conservation",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Design, Construction and Planning",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "Bachelor of Design"
                },
                {
                    "name": "Construction Management",
                    "degree": "Bachelor of Science in Construction Management"
                },
                {
                    "name": "Interior Design",
                    "degree": "Bachelor of Design"
                },
                {
                    "name": "Landscape Architecture (4-Year Professional Program)",
                    "degree": "Bachelor of Landscape Architecture"
                },
                {
                    "name": "Sustainability and the Built Environment",
                    "degree": "Bachelor of Science in Sustainability and the Built Environment"
                },
                {
                    "name": "Urban Sciences and Planning",
                    "degree": "Bachelor of Urban Sciences and Planning"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "Early Childhood Education (Age 3 - Grade 3)",
                    "degree": "Bachelor of Arts in Education"
                },
                {
                    "name": "Education Sciences",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Elementary Education (Grades K-6)",
                    "degree": "Bachelor of Arts in Education"
                }
            ]
        },
        {
            "name": "College of Health and Human Performance",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "Applied Physiology and Kinesiology",
                    "degree": "Bachelor of Science in Applied Physiology and Kinesiology"
                },
                {
                    "name": "Health Education and Behavior",
                    "degree": "Bachelor of Science in Health Education"
                },
                {
                    "name": "Sport Management",
                    "degree": "Bachelor of Science in Sport Management"
                },
                {
                    "name": "Tourism, Hospitality and Event Management",
                    "degree": "Bachelor of Science in Tourism, Hospitality and Event Management"
                }
            ]
        },
        {
            "name": "College of Journalism and Communications",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "Bachelor of Science in Advertising"
                },
                {
                    "name": "Journalism",
                    "degree": "Bachelor of Science in Journalism"
                },
                {
                    "name": "Media Production, Management, and Technology",
                    "degree": "Bachelor of Science in Media Production, Management, and Technology"
                },
                {
                    "name": "Public Relations",
                    "degree": "Bachelor of Science in Public Relations"
                }
            ]
        },
        {
            "name": "College of Liberal Arts and Sciences",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "African Languages",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Arabic",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Astronomy and Astrophysics",
                    "degree": "Bachelor of Arts in Astronomy"
                },
                {
                    "name": "Astronomy and Astrophysics",
                    "degree": "Bachelor of Science in Astrophysics"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Botany",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry (Biochemistry)",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chinese",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Classical Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Criminology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Dual Languages",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Foreign Languages and Literatures",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geography",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geography",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Geology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "German",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Hebrew",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Hispanic and Latin American Languages, Literatures and Linguistics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "International Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Italian",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Japanese",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Linguistics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Marine Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Meteorology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Microbiology and Cell Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Portuguese",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Religion",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Russian",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Spanish",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Spanish and Portuguese",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Statistics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Statistics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sustainability Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Women's Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Zoology",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Public Health and Health Professions",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "Bachelor of Health Science"
                },
                {
                    "name": "Health Science",
                    "degree": "Bachelor of Health Science"
                },
                {
                    "name": "Public Health",
                    "degree": "Bachelor of Public Health"
                }
            ]
        },
        {
            "name": "College of the Arts",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Art",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Art History",
                    "degree": "Bachelor of Arts in History of Art"
                },
                {
                    "name": "Dance",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Dance",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Digital Arts and Sciences",
                    "degree": "Bachelor of Arts in Digital Arts and Sciences"
                },
                {
                    "name": "Graphic Design",
                    "degree": "Bachelor of Fine Arts in Graphic Design"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Music Business and Entrepreneurship",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Music Education",
                    "degree": "Bachelor of Music in Music Education"
                },
                {
                    "name": "Theatre",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Theatre Performance",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Theatre Production",
                    "degree": "Bachelor of Fine Arts"
                }
            ]
        },
        {
            "name": "Hamilton School for Classical and Civic Education",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "American Government, History, Literature, and Law",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Great Books and Ideas",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy, Politics, Economics, and Law",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "War, Statecraft and Strategy",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Herbert Wertheim College of Engineering",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "Bachelor of Science in Aerospace Engineering"
                },
                {
                    "name": "Biological Engineering",
                    "degree": "Bachelor of Science in Biological Engineering"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "Bachelor of Science in Biomedical Engineering"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science in Chemical Engineering"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Science in Civil Engineering"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Science in Computer Engineering"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science in Computer Science"
                },
                {
                    "name": "Digital Arts and Sciences",
                    "degree": "Bachelor of Science in Digital Arts and Sciences"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Science in Electrical Engineering"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "Bachelor of Science in Environmental Engineering"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "Bachelor of Science in Industrial and Systems Engineering"
                },
                {
                    "name": "Industrialized Construction Engineering",
                    "degree": "Bachelor of Science in Industrialized Construction Engineering"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "Bachelor of Science in Materials Science and Engineering"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science in Mechanical Engineering"
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "Bachelor of Science in Nuclear Engineering"
                }
            ]
        },
        {
            "name": "Warrington College of Business",
            "source": {
                "label": "UF Undergraduate Catalog 2026-2027, Programs",
                "url": "https://catalog.ufl.edu/UGRD/programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Science in Accounting"
                },
                {
                    "name": "Business Administration (General Studies)",
                    "degree": "Bachelor of Arts in Business Administration"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Information Systems",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Management",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Science in Business Administration"
                }
            ]
        }
    ]
};

export default majors;
